{
  "page": {
    "title": "やること・お知らせ",
    "intro": "店がやること・確認することの一覧です（急ぎのものが上）。「開く」で直す画面へ直接移動します。",
    "kind": "種類",
    "status": "状態",
    "mine": "自分の担当だけ",
    "error": "やることの一覧を読み込めませんでした。",
    "empty_open": "いまやることはありません",
    "empty_open_body": "新しいやることは自動でここに表示されます。",
    "empty": "ここには何もありません。",
    "more": "もっと見る"
  },
  "kind_tab": {
    "all": "すべて",
    "alert": "問題",
    "task": "作業",
    "info": "新しい注文"
  },
  "status_tab": {
    "open": "未完了",
    "done": "完了",
    "all": "すべて"
  },
  "kind": {
    "alert": "問題",
    "task": "作業",
    "info": "お知らせ"
  },
  "status": {
    "open": "未対応",
    "in_progress": "対応中",
    "done": "完了",
    "dismissed": "終了"
  },
  "item": {
    "times_other": "×{{count}}",
    "assigned_me": "自分が担当",
    "assigned_to": "担当: {{name}}",
    "unassigned": "担当なし",
    "overdue": "期限切れ:",
    "due": "期限:",
    "me_name": "{{name}}（自分）",
    "someone": "スタッフ",
    "you": "自分"
  },
  "actions": {
    "open": "開く",
    "reopen": "未完了に戻す",
    "done": "完了",
    "assign_to": "担当者",
    "assign_me": "担当にする",
    "show_detail": "IT向けの詳細",
    "hide_detail": "詳細を閉じる"
  },
  "toast": {
    "done": "完了にしました。",
    "reopened": "やることに戻しました。",
    "assigned": "担当を{{name}}にしました。",
    "unassigned": "担当なしにしました。"
  },
  "alerts": {
    "legend": "新しいやることが来たとき",
    "sound": "音を鳴らす",
    "desktop": "このパソコンに通知を出す",
    "desktop_blocked": "このブラウザでは通知が許可されていません"
  },
  "dlq": {
    "for_it": "IT担当向け（お客様のデータは表示しません）",
    "service": "システムの部分",
    "subject": "更新の種類",
    "consumer": "処理担当",
    "count": "件数",
    "error": "エラー（短縮）",
    "how_to_retry": "IT担当はこのコマンドでも更新を送り直せます:",
    "runbook": "手順書: {{path}}",
    "retry": "送り直す（再送）",
    "retry_explain": "この種類の失敗した更新をもう一度送ります。うまくいくと、このやることは自動で閉じます。また失敗したときは新しいやることが出ます。",
    "ask_manager": "オーナーかマネージャーに「送り直す」を押してもらってください。",
    "command_title": "IT担当向け: コマンド",
    "sent_again_one": "{{count}}件の更新を送り直しました。",
    "sent_again_other": "{{count}}件の更新を送り直しました。",
    "some_left_one": "{{count}}件の更新は送り直せませんでした — IT担当の確認が必要です。",
    "some_left_other": "{{count}}件の更新は送り直せませんでした — IT担当の確認が必要です。"
  },
  "types": {
    "order_new": "新しい注文",
    "payment_confirm_pending": "入金確認待ち",
    "bank_transfer_notice": "お客様から振込済みの連絡",
    "payment_overdue": "入金が遅れています",
    "oversell_conflict": "同じカードが二重に売れました",
    "dlq_message": "バックグラウンド処理が失敗",
    "low_stock": "在庫が少ない",
    "taxfree_deadline": "免税：税関確認の期限",
    "taxfree_refund_due": "免税：返金する",
    "export_evidence_missing": "輸出の証拠がない",
    "payout_due": "委託者への支払い",
    "search_inconsistent": "サイト検索が古い",
    "search_dlq": "サイト検索の更新に失敗",
    "search_lag": "サイト検索の更新が遅い",
    "search_document_rejected": "商品を検索に入れられない",
    "document_integrity_mismatch": "保存した書類が変わっている",
    "document_failed": "書類を作れなかった",
    "notification_failed": "メールを送れなかった",
    "webhook_failed": "チャットに送れなかった",
    "document_missing": "書類がない",
    "tax_alert": "税金のお知らせ",
    "consignment_alert": "委託のお知らせ",
    "security_alert": "セキュリティのお知らせ",
    "staff_locked": "スタッフのアカウントがロック",
    "dsar_overdue": "個人情報の請求が遅れている",
    "queue_backlog": "処理がたまっている",
    "mail_setup_problem": "メール送信の設定に問題",
    "storage_threshold": "保存容量がもうすぐいっぱい",
    "order_alert": "注文の確認が必要",
    "return_request": "返品の依頼",
    "payment_alert": "支払いのお知らせ",
    "refund_failed": "返金に失敗",
    "inventory_orphaned": "商品のない在庫",
    "stock_discrepancy": "在庫数が合わない",
    "website_refresh_failed": "サイトが更新されていない可能性",
    "manual": "スタッフが書いたもの",
    "pending_payment_digest": "未入金注文の毎日の一覧",
    "daily_summary": "毎日のまとめ",
    "inbox_escalation": "急ぎのやることが残っている"
  },
  "settings": {
    "title": "通知",
    "intro": "誰に何を知らせるか、お客様に届くメール、送信したメールです。",
    "tab": {
      "people": "知らせる人",
      "emails": "お客様へのメール",
      "sent": "送信したメール"
    },
    "error": "通知の設定を読み込めませんでした。",
    "read_only": "この設定を変更できるのはオーナーだけです。見ることはできます。",
    "saved": "通知の設定を保存しました。",
    "conflict": "ほかの人が先に保存しました。最新の内容を表示しています — もう一度変更してください。",
    "save": "保存",
    "undo_changes": "変更を取り消す"
  },
  "recipients": {
    "title": "お知らせを受け取る人",
    "intro": "やることはすべて一覧に入ります。ここではメールやチャットでも受け取る人を選びます。",
    "everything": "すべてのお知らせを受け取る",
    "how_default": "方法（すべてのお知らせ）",
    "for_type": "「{{type}}」も受け取る",
    "how": "方法",
    "remove_type": "この行を削除",
    "add_type": "種類ごとに受け取る人を追加…",
    "nobody": "まだいません",
    "remove": "{{name}}を外す",
    "add_staff": "スタッフを追加…",
    "add_email": "またはメールアドレスを入力",
    "add": "追加",
    "bad_email": "メールアドレスの形ではありません。",
    "always_inbox": "やること一覧: 常に",
    "channel": {
      "email": "メール",
      "webhook": "チャット（Discord）"
    }
  },
  "webhooks": {
    "title": "チャット（Discord）",
    "intro": "お知らせをDiscordのチャンネルにも送れます。アドレスは秘密として保存され、保存後は表示されません。",
    "none": "チャットのチャンネルはまだありません。",
    "name": "名前",
    "url": "Discordのアドレス",
    "url_replace": "新しいアドレス（空欄なら今のまま）",
    "enabled": "オン",
    "all_alerts": "すべてのお知らせ",
    "some_alerts_other": "{{count}}種類のお知らせ",
    "test": "テスト送信",
    "remove": "削除",
    "add": "チャットのチャンネルを追加",
    "test_sent": "テストメッセージを送りました。",
    "test_failed": "チャットがテストメッセージを受け付けませんでした。アドレスを確認してください。"
  },
  "sender": {
    "title": "店のメールの送信者",
    "name": "送信者名（{{language}}）",
    "address": "送信元アドレス",
    "reply_to": "返信先",
    "empty_uses_default": "空欄のときは灰色の値を使います。"
  },
  "times": {
    "title": "時刻",
    "digest": "未入金注文の一覧を送る時刻",
    "daily_summary": "毎日のまとめを送る時刻",
    "low_stock": "残りがこの数以下で「在庫が少ない」"
  },
  "problems": {
    "from_address": "送信元アドレスがメールアドレスではありません。",
    "reply_to": "返信先がメールアドレスではありません。",
    "digest_time": "時刻は「時:分」で入力してください。",
    "daily_summary_time": "まとめの時刻は「時:分」で入力してください。",
    "low_stock": "在庫が少ない: 整数で入力してください。",
    "webhook_url": "新しいチャットにはDiscordの https:// アドレスが必要です。",
    "webhook_name": "チャットのチャンネルには名前が必要です。"
  },
  "lang": {
    "en": "English",
    "ja": "日本語",
    "th": "ไทย",
    "zh-Hant": "繁體中文",
    "zh-Hans": "简体中文"
  },
  "emails": {
    "intro": "お客様に届くメールを見本データで表示します。文面の変更はシステム担当が行います — この画面は表示だけです。",
    "which": "メール",
    "off": "オフ",
    "language": "言語",
    "send_test": "自分にテスト送信（{{email}}）",
    "error": "メールを読み込めませんでした。",
    "preview_error": "このメールを表示できませんでした。",
    "subject": "件名",
    "fallback": "この言語ではまだ書かれていません — お客様には{{language}}版が届きます。",
    "frame_title": "メール: {{subject}}",
    "show_text": "テキスト版を表示",
    "hide_text": "テキスト版を閉じる",
    "test_sent": "{{email}} にテストメールを送りました。"
  },
  "sent": {
    "failed_only": "失敗したメールだけ",
    "error": "送信したメールを読み込めませんでした。",
    "empty": "メールはありません。",
    "hidden": "非表示",
    "open": "開く",
    "one_title": "メール",
    "resend": "もう一度送る",
    "resent": "メールをもう一度送ります。",
    "to": "宛先",
    "state": "状態",
    "when": "日時",
    "problem": "問題",
    "body_hidden": "内容はお客様情報を見られるスタッフだけが見られます。",
    "body_gone": "このメールの控えはもう保存されていません。",
    "status": {
      "queued": "待機中",
      "sending": "送信中",
      "sent": "送信済み",
      "failed": "失敗",
      "suppressed": "送信せず（このアドレスには送れません）",
      "bounced": "戻ってきた",
      "skipped": "送信せず（お客様がオフ）"
    },
    "error_code": {
      "other": "メールサーバーが受け付けませんでした。"
    }
  }
}
